module.exports = __webpack_public_path__ + "img/file-04.db63c358.svg";